import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import { FAST_TIMER } from '~/const/timers';
import fetchProductList from '~/services/layer';
import { fetchProducts } from '~/services/product';
function timer() {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, FAST_TIMER);
  });
}
export default {
  fetchProducts(store, payload) {
    var _this = this;
    return _asyncToGenerator(function* () {
      store.commit(types.SET_LOADING_LAYER, true);
      var currentState = store.state;
      if (payload.security) {
        yield timer();
      }
      if (payload.payload !== currentState.latest) {
        return;
      }
      var productList = yield fetchProductList(_this, payload.payload);
      var products = yield fetchProducts(_this, productList);
      if (payload.payload !== currentState.latest) {
        return;
      }
      var filteredProducts = products.filter(product => product.stock.status !== null);
      store.commit(types.SET_LAYER_PRODUCTS, filteredProducts);
      productList = null;
      products = null;
      store.commit(types.SET_LOADING_LAYER, false);
    })();
  },
  resetProducts(_ref) {
    var {
      commit
    } = _ref;
    commit(types.RESET_LAYER_PRODUCTS, []);
  },
  setCurrentLayer(store, payload) {
    var data = payload;
    store.commit(types.SET_CURRENT_LAYER, data);
    data = null;
  },
  appendItems(store, payload) {
    store.commit(types.APPEND_ITEMS, payload);
  }
};